(function ($, Global) {
	var fnInterval;
    function AlertesCarouselComponent() {
        // Déclaration class objet
    }

	AlertesCarouselComponent.prototype.initEvents = function () {
		this.publishers();
	}

	AlertesCarouselComponent.prototype.publishers = function () {
		intervalNext();

		$(document).on('click', '.alertes-carousel-control', function (e) {
			e.preventDefault();

			clearInterval(fnInterval);
			onNextAlerte();
			intervalNext();
		});
	}

	function intervalNext() {
		var $alertes = $('.alertes-carousel');
		var interval = $alertes.data('carousel-interval') || 3000;

		fnInterval = setInterval(function () {
			onNextAlerte();
		}, interval);
	}  

	function onNextAlerte() {
		var $alertes = $('.alertes-carousel');
		var nbAlertes = $alertes.find('.item').length;
        var $parent = $alertes.find('.carousel-content');

        if (nbAlertes > 1) {
            var $itemActif = $alertes.find('.item.active');
            var indexItemActif = $alertes.find('.item').index($itemActif);
            var nextIndex = indexItemActif + 1;
            var $nextItem = $alertes.find('.item:eq(' + nextIndex + ')');

            if (!$nextItem.exists() || !$parent.exists()) return;

            var scrollLeft = $nextItem.offset().left - $parent.offset().left;

            $itemActif.removeClass('active');
            $nextItem.addClass('active');

            $parent.animate({
                scrollLeft: scrollLeft
            }, 800, function () {
                $alertes.find('.item').last().after($itemActif);
                $parent.scrollLeft(0);
            });
        }		
	}

	Global.AlertesCarouselComponent = AlertesCarouselComponent;
}(jQuery, window));